import { render, staticRenderFns } from "./clientdashboard-forgot-password.vue?vue&type=template&id=0a47696c&"
import script from "./clientdashboard-forgot-password.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-forgot-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports